import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Grid, Button, Snackbar, Typography, Box } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import ContactDetailField from "../../../molecules/ContactDetailField";
import Input from "../../../atoms/Input";
import DynamicText from "../../../molecules/DynamicText";
import { useParams, useLocation } from "react-router-dom";
import FourOptionsDynamicCheckbox from "../../../molecules/FourOptionsCheckbox";
// import "./style.css";
import PrintComponent from "../../PrintComponent";
import LoadUnloadDownload from "./download";
import moment from "moment";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import InventoryIcon from "@mui/icons-material/Inventory";
import CommentIcon from "@mui/icons-material/Comment";
import GavelIcon from "@mui/icons-material/Gavel";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import NoteAltIcon from "@mui/icons-material/NoteAlt";

const LoadUnloadReportClientSide = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");

  const [surveyData, setSurveyData] = useState([])

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data) => {
    setIsLoading(true);

    let media = [];
    if (formContent?.clientSign != "") media[0] = formContent?.clientSign;

    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: media,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        if (data != undefined)
          setSnackbarMessage("Signature has been added successfully!");
        else
          setSnackbarMessage("LOAD/UNLOAD Form has been updated successfully!");

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);


  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");

  //
  //
  const uploadFile = async (event) => {
    event.preventDefault();

    if (event.target.files.length > 0) {
      const fd = new FormData();
      fd.append("image", event.target.files[0]);

      imageUploadClientPreview(fd, surveyId, formId, email, token)
        .then((res) => {
          let values = { ...formContent };
          values.clientSign = res?.data?.data?.key;
          setFormContent(values);

          setTimeout(() => {
            updateContent(values);
          }, 1500);
          setIsLoading(false);
        })
        .catch((error) => {
          setSnackbarMessage(error?.response?.data?.message);
          setOpenSnackbar(true);

          setIsValid(false);

          setIsLoading(false);
        });
    }
  };


  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
          title="Load Unload Report"
          hideBackButton={true}
          actions={
            <div className="d-flex gap-3">
               {!isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    setIsEdit(true);
                  }}
                  disabled={isLoading}
                  sx={{ 
                    textTransform: "none", 
                    borderRadius: "var(--radius-md)", 
                    padding: "10px 24px",
                    fontWeight: 700,
                    backgroundColor: "var(--primary-color)",
                    boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                    '&:hover': { backgroundColor: 'var(--primary-hover)' }
                  }}
                  startIcon={<NoteAltIcon />}
                >
                  Edit
                </Button>
              )}
               {isEdit && (
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    getContent();
                    setIsEdit(false);
                  }}
                  disabled={isLoading}
                   sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
                >
                  Cancel
                </Button>
              )}

               {isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    updateContent();
                  }}
                  disabled={isLoading}
                   sx={{ 
                    textTransform: "none", 
                    borderRadius: "var(--radius-md)", 
                    padding: "10px 32px",
                    fontWeight: 700,
                    backgroundColor: "var(--primary-color)",
                    boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                    '&:hover': { backgroundColor: 'var(--primary-hover)' }
                  }}
                >
                  Save
                </Button>
              )}

               {!isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                                const tempTitle = document.title;
                    const newTitle = `Load-Unload-Report-${formContent?.clientName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
                    document.title = newTitle;
                    
                    // Standardized delay for print and title restoration
                    setTimeout(() => {
                        window.print();
                        setTimeout(() => {
                            document.title = tempTitle;
                        }, 2000);
                    }, 500);
                }}
                  disabled={isLoading}
                   sx={{ 
                    textTransform: "none", 
                    borderRadius: "var(--radius-md)", 
                    padding: "10px 24px",
                    fontWeight: 700,
                    backgroundColor: "var(--text-main)",
                    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                    '&:hover': { backgroundColor: '#000' }
                  }}
                  startIcon={<DescriptionIcon />}
                >
                  Save as PDF
                </Button>
              )}
            </div>
          }
        >
        <SectionHeader title="Details" icon={<DescriptionIcon />} />
        <PremiumCard sx={{ marginBottom: "32px" }}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                     <ContactDetailField
                      label="File Ref"
                      isEdit={isEdit}
                      type="text"
                      minWidth={"100%"}
                      value={formContent?.fileRef}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.fileRef = e.target.value;
                        setFormContent(values);
                      }}
                      disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <ContactDetailField
                      label="Customer Name"
                      isEdit={isEdit}
                      type="text"
                      minWidth={"100%"}
                      value={formContent?.clientName}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.clientName = e.target.value;
                        setFormContent(values);
                      }}
                      disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                     <ContactDetailField
                      label="Driver Name"
                      isEdit={isEdit}
                      type="text"
                      minWidth={"100%"}
                      value={formContent?.driverName}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.driverName = e.target.value;
                        setFormContent(values);
                      }}
                      disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <ContactDetailField
                      label="Contact No."
                      isEdit={isEdit}
                      type="number"
                      minWidth={"100%"}
                      value={formContent?.contactNo}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.contactNo = e.target.value;
                        setFormContent(values);
                      }}
                      disabled
                    />
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                    <ContactDetailField
                      label="ID Card No."
                      isEdit={isEdit}
                      type="number"
                      minWidth={"100%"}
                      value={formContent?.idNo}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.idNo = e.target.value;
                        setFormContent(values);
                      }}
                      disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                     <ContactDetailField
                      label="Origin Address"
                      isEdit={isEdit}
                      type="text"
                      minWidth={"100%"}
                      value={formContent?.originAddress}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.originAddress = e.target.value;
                        setFormContent(values);
                      }}
                      disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <ContactDetailField
                        label="Date"
                        isEdit={isEdit}
                        type="date"
                        minWidth={"100%"}
                        value={formContent?.date}
                        onChange={(e) => {
                          let values = { ...formContent };
                          values.date = e.target.value;
                          setFormContent(values);
                        }}
                        disabled
                      />
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                    <ContactDetailField
                        label="Organization"
                        isEdit={isEdit}
                        type="text"
                        minWidth={"100%"}
                        value={formContent?.organization}
                        onChange={(e) => {
                          let values = { ...formContent };
                          values.organization = e.target.value;
                          setFormContent(values);
                        }}
                        disabled
                      />
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                     <ContactDetailField
                        label="Serial No."
                        isEdit={isEdit}
                        type="text"
                        minWidth={"100%"}
                        value={formContent?.serialNo}
                        onChange={(e) => {
                          let values = { ...formContent };
                          values.serialNo = e.target.value;
                          setFormContent(values);
                        }}
                        disabled
                      />
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                     <ContactDetailField
                        label="Truck No."
                        isEdit={isEdit}
                        type="text"
                        minWidth={"100%"}
                        value={formContent?.truckNo}
                        onChange={(e) => {
                          let values = { ...formContent };
                          values.truckNo = e.target.value;
                          setFormContent(values);
                        }}
                        disabled
                      />
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                     <ContactDetailField
                        label="Container No."
                        isEdit={isEdit}
                        type="text"
                        minWidth={"100%"}
                        value={formContent?.containerNo}
                        onChange={(e) => {
                          let values = { ...formContent };
                          values.containerNo = e.target.value;
                          setFormContent(values);
                        }}
                        disabled
                      />
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                    <ContactDetailField
                      label="Destination Address"
                      isEdit={isEdit}
                      type="text"
                      minWidth={"100%"}
                      value={formContent?.destinationAddress}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.destinationAddress = e.target.value;
                        setFormContent(values);
                      }}
                      disabled
                    />
                </Grid>
            </Grid>
        </PremiumCard>
          {/* /file detail */}

            {/* Shipment Details */}
            <SectionHeader title="Shipment Details" icon={<LocalShippingIcon />} />
            <PremiumCard sx={{ marginBottom: "32px" }}>
              <div className="pt-3">
                <Typography variant="body1" className="text-start" gutterBottom>
                  <FourOptionsDynamicCheckbox
                    label="Shipment Mode"
                    checkId1="check1"
                    checkLabel1="Import"
                    checkId2="check2"
                    checkLabel2="Export"
                    checkId3="check3"
                    checkLabel3="Local"
                    checkId4="chec42"
                    checkLabel4="Storage"
                    value1={formContent?.shipmentMode == "import" ? true : false}
                    value2={formContent?.shipmentMode == "export" ? true : false}
                    value3={formContent?.shipmentMode == "local" ? true : false}
                    value4={formContent?.shipmentMode == "storage" ? true : false}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.shipmentMode = "import";
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.shipmentMode = "export";
                      setFormContent(values);
                    }}
                    onChange3={(e) => {
                      let values = { ...formContent };
                      values.shipmentMode = "local";
                      setFormContent(values);
                    }}
                    onChange4={(e) => {
                      let values = { ...formContent };
                      values.shipmentMode = "storage";
                      setFormContent(values);
                    }}
                    disabled={true}
                  />
                </Typography>
              </div>

              <div className="mt-3">
                 <Typography variant="body1" className="text-start" gutterBottom>
                  <FourOptionsDynamicCheckbox
                    label="Nature of Shipment"
                    checkId1="check1"
                    checkLabel1="Loose Items"
                    checkId2="check2"
                    checkLabel2="Lift Vans"
                    checkId3="check3"
                    checkLabel3="Vehicle"
                    checkId4="chec42"
                    checkLabel4="Bike"
                    value1={
                      formContent?.shipmentNature == "loose-items" ? true : false
                    }
                    value2={
                      formContent?.shipmentNature == "lift-vans" ? true : false
                    }
                    value3={formContent?.shipmentNature == "vehicle" ? true : false}
                    value4={formContent?.shipmentNature == "bike" ? true : false}
                    onChange1={(e) => {
                      let values = { ...formContent };
                      values.shipmentNature = "loose-items";
                      setFormContent(values);
                    }}
                    onChange2={(e) => {
                      let values = { ...formContent };
                      values.shipmentNature = "lift-vans";
                      setFormContent(values);
                    }}
                    onChange3={(e) => {
                      let values = { ...formContent };
                      values.shipmentNature = "vehicle";
                      setFormContent(values);
                    }}
                    onChange4={(e) => {
                      let values = { ...formContent };
                      values.shipmentNature = "bike";
                      setFormContent(values);
                    }}
                    disabled={true}
                  />
                </Typography>
              </div>
            </PremiumCard>

            {/* Containers */}
            <SectionHeader title="Containers" icon={<InventoryIcon />} />
             <PremiumCard sx={{ marginBottom: "32px" }}>
              <div className="d-flex flex-wrap mt-2">
                {formContent?.containers?.map((cn, ind) => {
                  return (
                    <div
                      key={ind}
                      className={`cursor-pointer ${
                        cn ? "blue-container-div" : "container-div"
                      }`}
                      style={{
                          margin: '5px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: cn ? '#1976d2' : '#f5f5f5',
                          color: cn ? '#fff' : '#333',
                          border: '1px solid #ddd',
                          fontWeight: 'bold'
                      }}
                      onClick={() => {
                        if (isEdit) {
                          let values = { ...formContent };
                          let contValues = [...formContent?.containers];
                          contValues[ind] = !contValues[ind];
                          values.containers = contValues;
                          setFormContent(values);
                        }
                      }}
                    >
                      {" "}
                      {ind + 1}
                    </div>
                  );
                })}
              </div>
             </PremiumCard>

             {/* Discrepancies */}
             <SectionHeader title="Discrepancies" icon={<InventoryIcon />} />
             <PremiumCard sx={{ marginBottom: "32px" }}>
                 <Grid container spacing={3}>
                      <Grid item xs={12} className="mb-3">
                        <ContactDetailField
                            label="Double No."
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.doubleNo}
                            onChange={(e) => {
                              let values = { ...formContent };
                              values.doubleNo = e.target.value;
                              setFormContent(values);
                            }}
                            disabled={true}
                             placeholder="Double No. separated by commas"
                        />
                      </Grid>
                       <Grid item xs={12} className="mb-3">
                          <ContactDetailField
                            label="Missing No."
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.missingNo}
                            onChange={(e) => {
                              let values = { ...formContent };
                              values.missingNo = e.target.value;
                              setFormContent(values);
                            }}
                            disabled={true}
                             placeholder="Missing No. separated by commas"
                        />
                      </Grid>
                       <Grid item xs={12}>
                        <ContactDetailField
                            label="Apparent damages No."
                            isEdit={isEdit}
                            type="text"
                            minWidth={"100%"}
                            value={formContent?.damagesNo}
                            onChange={(e) => {
                              let values = { ...formContent };
                              values.damagesNo = e.target.value;
                              setFormContent(values);
                            }}
                            disabled={true}
                             placeholder="Apparent damages No. separated by commas"
                        />
                      </Grid>
                 </Grid>
             </PremiumCard>


             {/* Remarks */}
           <SectionHeader title="Remarks" icon={<CommentIcon />} />
           <PremiumCard sx={{ marginBottom: "32px" }}>
            <div className="pe-1">
             <Typography variant="body1" className="text-start" gutterBottom>
               <DynamicText
                 label="Remarks:"
                 textAreaLabel="Remarks..."
                 isEdit={isEdit}
                 value={formContent?.remarks}
                 onChange={(e) => {
                   let values = { ...formContent };
                   values.remarks = e.target.value;
                   setFormContent(values);
                 }}
                 disabled={true}
               />
             </Typography>
            </div>
           </PremiumCard>

           {/* Authorization */}
           <SectionHeader title="Authorization" icon={<GavelIcon />} />
           <PremiumCard sx={{ marginBottom: "32px" }}>
              <Grid container spacing={4} sx={{ mt: 2 }}>
                <Grid item xs={12} sm={6}>
                  <div style={{ height: "90px" }} className="d-flex justify-content-center align-items-end">
                    {formContent?.supervisorSign?.trim()?.length > 0 && (
                      <img src={`${Bucket}${formContent?.supervisorSign}`} height={80} alt="Supervisor Sign" />
                    )}
                  </div>
                  <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                  <p className="my-1 text-center">
                    <b>{"Supervisor/Carrier"}</b>
                  </p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div style={{ height: "90px" }} className="d-flex justify-content-center align-items-end">
                    {formContent?.ownerSign?.trim()?.length > 0 && (
                      <img src={`${Bucket}${formContent.ownerSign}`} height={80} alt="Owner Sign" />
                    )}
                  </div>
                  <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                  <p className="my-1 text-center">
                    <b>{"Owner/Authorized"}</b>
                  </p>
                </Grid>
              </Grid>
            </PremiumCard>
        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <LoadUnloadDownload surveyData={surveyData} formContent={formContent} />
      </PrintComponent>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* /snackbar */}
    </>
  );
};

export default LoadUnloadReportClientSide;
